import React from 'react';
import { ScrollerStyle as S } from './Scroller.style';

type ScrollerProps = {
  axis?: 'y' | 'x';
  testId?: string;
  className?: string;
  children?: React.ReactNode;
  hideScrollbar?: boolean;
};

export const Scroller = React.forwardRef<HTMLDivElement, ScrollerProps>(
  ({ className, children, testId, ...props }, ref) => {
    return (
      <S.Scroller $props={props} className={className} data-testid={testId} ref={ref}>
        {children}
      </S.Scroller>
    );
  }
);
